const DEFAULT_MESSAGE = 'Si è verificato un errore, riprova più tardi.';
const TOO_MANY_REQUESTS_MESSAGE = 'Troppi tentativi, riprova tra un minuto.';

/**
 * Messaggio da mostrare all'utente per una chiamata API fallita.
 *
 * Le risposte d'errore dell'API hanno la forma standard di Laravel:
 * - 422: { message, errors: { campo: [messaggi] } }, si mostra il primo errore di campo;
 * - 403, 404, 409: { message }.
 * Gli endpoint non ancora convertiti rispondono ancora { error }: si legge anche quello.
 * Per errori di rete, 429 e 5xx il testo dell'API non è utile e si usa un messaggio fisso.
 *
 * @param {object} error           errore di axios
 * @param {string} fallbackMessage messaggio quando la risposta non ne porta uno
 * @returns {string}
 */
export function errorMessage(error, fallbackMessage = DEFAULT_MESSAGE) {
  const response = error?.response;

  if (!response) return fallbackMessage;
  if (response.status === 429) return TOO_MANY_REQUESTS_MESSAGE;
  if (response.status >= 500) return fallbackMessage;

  const data = response.data || {};
  const firstFieldError = firstError(data.errors);

  return firstFieldError || data.message || data.error || fallbackMessage;
}

// Primo messaggio dell'oggetto errors di una risposta 422, se presente
function firstError(errors) {
  if (!errors || typeof errors !== 'object') return null;

  const messages = Object.values(errors).flat();

  return messages.find((message) => typeof message === 'string' && message) || null;
}
